import React, { useState } from "react";
import { sendmail, verifyOtp, resendotp } from "../../../functions/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../index.css";
import Loading from "../../../modal/Loading";

const Index = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [resend, setResend] = useState(false);
  const [userId, setUserID] = useState("");
  const [otp, setOtp] = useState("");
  const naviagte = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sendmail(email)
        .then((res) => {
          setLoading(false);
          setUserID(res.data.data.userId);
          //   console.log(res);
          toast.success(res.data.meassage || "Verification otp email sent");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(
            err.response.data.message ||
              "Your Email is not registered with us. Please Sign up and try again."
          );
        });
    } catch (error) {
      toast.error(error);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await verifyOtp(userId, otp)
        .then((res) => {
          //   console.log(res);
          setLoading(false);
          toast.success(
            res.data.data.message || "User OTP verified successfully."
          );
          naviagte("/generate-password", {
            state: { userId: userId, email: email },
          });
        })
        .catch((err) => {
          //   console.log(err.response.data.message);
          toast.error(
            err.response.data.message ||
              "Invalid code passed. Check your inbox."
          );
          setLoading(false);
        });
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }
  };

  const resendOtp = async (e) => {
    e.preventDefault();
    setResend(true);
    setLoading(true);
    try {
      if (email) {
        await resendotp(email)
          .then((res) => {
            setResend(false);
            setLoading(false);
            setUserID(res.data.data.userId);
            toast.success(res.data.meassage || "Verification otp email sent");
          })
          .catch((err) => {
            setResend(false);
            setLoading(false);
            toast.error(
              err.response.data.message ||
                "Your Email is not registered with us. Please Sign up and try again."
            );
          });
      } else {
        setResend(false);
        setLoading(false);
        toast.error("Empty Email address is not allowed.");
      }
    } catch (error) {
      setResend(false);
      setLoading(false);
      toast.error(error);
    }
  };

  const forgotform = () => (
    <form>
      <div className="form-group mt-4">
        <input
          type="email"
          className="form-control"
          value={email}
          name="email"
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          autoFocus
          autoComplete="true" //off
          disabled={userId !== ""}
        />
      </div>
      {userId !== "" && (
        <>
          <div className="form-group mt-4">
            <input
              type="text"
              className="form-control"
              value={otp}
              name="otp"
              onChange={(e) => setOtp(e.target.value)}
              placeholder="OTP"
              autoFocus
              autoComplete="true" //off
            />
          </div>
          <button
            onClick={handleVerify}
            className="mb-3 mt-4 w-100 btnlogin"
            disabled={!otp}
          >
            {loading ? <div>Verifing....</div> : <div>Verify OTP</div>}
          </button>
        </>
      )}
      {userId === "" && (
        <button
          onClick={handleSubmit}
          className="mb-3 mt-3 w-100 btnlogin"
          disabled={!email}
        >
          {loading ? <div>Sending....</div> : <div>Sent OTP</div>}
        </button>
      )}
    </form>
  );

  console.log("email", email);
  console.log("userId", userId);

  return (
    <div>
      {loading && <Loading />}
      <div className="container1">
        <div className="loginheader">
          <h2>Pronto</h2>
        </div>
        <div className="form-group mt-4"></div>
        <div className="pcont">
          <div className="p-4">
            <div className="row">
              <div className="col-md-4 offset-md-4">
                <div className="textJ">Forgot Password</div>
                <div
                  className="textJ mt-2"
                  style={{ fontSize: "12px", fontWeight: "400" }}
                >
                  Pronto by Health Monitor Network
                </div>

                {forgotform()}

                <div
                  className="textJ"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    textDecorationLine: "underline",
                    color: "black",
                    cursor: "pointer",
                  }}
                  onClick={resendOtp}
                >
                  Resend OTP
                </div>
                {resend && (
                  <div
                    className="request textJ mt-1 "
                    style={{
                      fontWeight: "500",
                    }}
                  >
                    requesting..
                  </div>
                )}
                <div
                  className="textJ mt-1"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "black",
                  }}
                >
                  Admin Forgot password
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
